import React from 'react';
import { pluginCode } from 'drapcode-constant';
import MagicLinkLogin from './MagicLinkLogin';
import Twilio from './Twilio';
import AwsSns from './AwsSns';
import Subscribe from './Subscribe';
import Plaid from './Plaid';
import GoogleAnalytics from './GoogleAnalytics';
import AtomChat from './AtomChat';
import MultiTenant from './MultiTenant';
import StripeConnect from './StripeConnect';
import Snipcart from './Snipcart';
import AmazonSes from './AmazonSes';
import Login from './Login';
import GoogleMap from './GoogleMap';

const ShowPluginDocs = ({ code }) => {
  switch (code) {
    case pluginCode.LOGIN:
      return <Login />;
    case pluginCode.GOOGLE_MAP:
      return <GoogleMap />;
    case pluginCode.AWS_SES:
      return <AmazonSes />;
    case pluginCode.SNIPCART:
      return <Snipcart />;
    case 'STRIPE_CONNECT':
      return <StripeConnect />;
    case pluginCode.MULTI_TENANT_SAAS:
      return <MultiTenant />;
    case pluginCode.ATOM_CHAT:
      return <AtomChat />;
    case pluginCode.GOOGLE_ANALYTICS:
      return <GoogleAnalytics />;
    case pluginCode.PLAID:
      return <Plaid />;
    case pluginCode.SUBSCRIBE:
      return <Subscribe />;
    case pluginCode.TWILIO:
      return <Twilio />;
    case pluginCode.AWS_SNS:
      return <AwsSns />;
    case pluginCode.MAGIC_LINK_LOGIN:
      return <MagicLinkLogin />;
    default:
      return '';
  }
  return <div>ShowPluginDocs</div>;
};

export default ShowPluginDocs;
